import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import {
  Autocomplete,
  Box,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import TrainIcon from "@mui/icons-material/Train";
import { Delete, FmdBad, FmdGood, LocalHospital } from "@mui/icons-material";
import { application, telemetry } from "globals/endpoints";
import React, { useEffect, useState, useRef } from "react";
import { useQuery } from "react-query";
import loggerFactory from "globals/logger/logger-factory";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import "../../../../App.css";
import {
  useMaterialUIController,
  setClickToCall,
  setIsPreRecordBroadcast,
  setBroadCastCallType,
} from "context";
import { alpha } from "@mui/material/styles";
import dialog from "assets/theme/components/dialog";
import CTLDialogContent from "../../styles/CTLDialogContent";
import L from "leaflet";
import "leaflet-draw";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import MicIcon from "@mui/icons-material/Mic";
import CampaignIcon from "@mui/icons-material/Campaign";
import CallIcon from "@mui/icons-material/Call";
import GroupIcon from "@mui/icons-material/Group";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import ForumIcon from "@mui/icons-material/Forum";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CropFreeIcon from "@mui/icons-material/CropFree";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import CTLNotification from "application/components/CTLNotification";
import { setIvrExtension } from "context";
import MapControls from "../MapControls";
import DispatcherGroupCall from "../DispatcherGroupCall";
import { useTheme } from "@mui/material/styles";
import PentagonIcon from "@mui/icons-material/Pentagon";
import RouteIcon from "@mui/icons-material/Route";
import { setIsPublicEmergencyCall } from "context";
import { setRTCEvent } from "context";
import { setClickToVideoCall } from "context";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import UserRouteDialog from "./UserRouteDialog";
import { setAmbientMode } from "context";
import LiveGroupCall from "../LiveGroupCall";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import {
  useGetAllGeofencesQuery,
  useUpdateGeofenceMutation,
} from "features/geofenceSlice";
import { clearGeofenceRedraw } from "features/geofenceUiSlice";
import GeofenceEditorDialog from "application/modules/Dispatcher/GeofencePanel/GeofenceEditorDialog";

function AreaSelect({ onAreaSelect }) {
  useEffect(() => {
    if (!map) {
      map = L.map("map");
      if (map) {
        map.selectArea.enable();

        map.on("areaselected", (e) => {
          onAreaSelect(e.bounds);
        });
      }
    }
  }, [onAreaSelect]);

  return null;
}

export default function DefaultView({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  onContactAction,
}) {
  const Attributes = {
    enableSelectDispatcherMenu: true,
    keyField: "department",
    label: "Select Department",
    value: AuthenticationService.getDepartmentList(),
    modes: [],
  };
  const userName = AuthenticationService.getUserName();
  const UserNumber = AuthenticationService.getExtensionNumber();
  const [controller, dispatch] = useMaterialUIController();
  const { activePage, dispatcherDepartment, dragAndDropEvent } = controller;
  const dragAndDropEventRef = useRef(dragAndDropEvent);
  useEffect(() => {
    dragAndDropEventRef.current = dragAndDropEvent;
  }, [dragAndDropEvent]);

  const [openUserDialog, setOpenUserDialog] = useState(false);
  const [isZDValid, setIsZDValid] = useState(true);
  const [isFileValid, setIsFileValid] = useState(true);
  const [isMessageValid, setIsMessageValid] = useState(true);
  const [userPaths, setUserPaths] = useState([]);
  const [liveGroupCallOpen, setLiveGroupCallOpen] = useState(false);
  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks && registerCallBacks({
      onNMSSelect: (value, departmentMeta) => {
        const resolvedDepartment = resolveDepartmentSelection(value, departmentMeta);
        selectedDepartmentRef.current = resolvedDepartment.name || "";
        setSelectedDepartment(resolvedDepartment.name || "");
        setDrawingColor(resolvedDepartment.color || "grey");
      },
    });
  }, [activePage, pageId]);

  useEffect(() => {
    setIvrExtension(dispatch, "");
  }, [activePage]);

  const componentName = "MAP";
  loggerFactory.debug(
    componentName,
    "Location : " + AuthenticationService.getLocation(),
  );
  const mapRef = useRef();
  const drawItemRef = useRef();
  const drawControlRef = useRef();
  const editHandlerRef = useRef(null);
  const areaLayer = L.layerGroup();
  const routeLayer = L.layerGroup();

  // Geofence draw tool - kept separate from the broadcast-call "Draw Area"
  // tool above so the two features never interfere with each other.
  const geofenceDrawItemRef = useRef();
  const geofenceDrawControlRef = useRef();
  const geofenceDrawModeRef = useRef(false);
  const savedGeofenceLayerRef = useRef();
  const pendingGeofenceLayerRef = useRef(null);
  const [geofenceDrawActive, setGeofenceDrawActive] = useState(false);
  const [geofenceEditorOpen, setGeofenceEditorOpen] = useState(false);
  const [pendingGeofenceShape, setPendingGeofenceShape] = useState(null);
  const [editingGeofence, setEditingGeofence] = useState(null);

  const markerRefs = useRef({});
  const intervalRefs = useRef({});
  const indexRefs = useRef({});
  const userStatus = useRef({});
  const timeoutRefs = useRef({});
  const isMarkerVisible = useRef(true);
  const department =  AuthenticationService?.getDepartmentList()?.map((dept) => dept.department);
  const mapContainerRef = useRef(null);
  const { darkMode, ivrExtension } = controller;
  const imagePath = process.env.PUBLIC_URL + "/images/base.png";
  const [northZoneColor, setNorthZoneColor] = useState("success");
  const [southZoneColor, setSouthZoneColor] = useState("success");
  const [selectedZone, setSelectedZone] = useState(false);
  const [clickButtonName, setClickButtonName] = useState("");
  const [messageToBroadcast, setMessageToBroadcast] = useState("");
  const [message, setMessage] = useState("");
  const [selectedMarker, setSelectedMarker] = useState("");
  const [selectedMarkerTransferCall, setSelectedMarkerTransferCall] = useState({
    select: {},
    marker: {},
  });
  const [zoneList, setZoneList] = useState([]);
  const [departmentList, setDepartmentList] = useState(
    AuthenticationService.getDepartmentList(),
  );
  const [fileList, setFileList] = useState();
  const [selectZD, setSelectZD] = useState("");
  const [selectFile, setSelectFile] = useState("");
  const [showSelect, setShowSelect] = useState(false);
  const [nearestMarkers, setNearestMarkers] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const selectedDepartmentRef = useRef(selectedDepartment);
  const [drawingColor, setDrawingColor] = useState("grey");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [open, setOpen] = useState(false);
  const [openOnCreate, setOpenOnCreate] = useState(false);
  const [groupList, setGroupList] = useState("");
  const [isDrawing, setIsDrawing] = useState(false);
  const [hasDrawnShape, setHasDrawnShape] = useState(false);
  const [locationUpdateColor, setLocationUpdateColor] = useState("warn");
  const [data, setData] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const [routeData, setRouteData] = useState([]);
  const [showArea, setShowArea] = useState(
    localStorage.getItem("Show-Area") === "true",
  );
  const [showRoute, setShowRoute] = useState(
    localStorage.getItem("Show-Route") === "true",
  );
  const [map, setMap] = useState(null);
  const [mapMode, setMapMode] = useState("standard"); // 'standard' | 'satellite'
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isStreetViewMode, setIsStreetViewMode] = useState(false);
  const tileLayerRef = useRef(null);
  const isDisable = AuthenticationService.allowMCXDispatcher();
  const mapMaxZoom = Number(AuthenticationService.getMapMaxZoom()) || 17;
  const mapMinZoom = Number(AuthenticationService.getMapMinZoom()) || 10;
  const mapDefaultZoom =
    Number(AuthenticationService.getMapDefaultZoom()) || 12;
  const mapURL = AuthenticationService.getMapUrl();
  const urlScheme = window.location.protocol === "https:" ? "https:" : "http:";
  const [homeLocation, setHomeLocation] = useState(
    AuthenticationService.getLocation() || AuthenticationService.getMapCenter(),
  );
  const [zoomLevel, setZoomLevel] = useState(mapDefaultZoom);

  const resolveDepartmentSelection = (value, departmentMeta) => {
    const normalizedMeta =
      departmentMeta && typeof departmentMeta === "object" ? departmentMeta : null;
    const valueAsText =
      typeof value === "string"
        ? value
        : value?.department || value?.name || value?.label || "";

    const matchedDepartment = departmentList?.find((departmentItem) => {
      // Match strictly on the department CODE (`department`); fall back to the
      // extension only so a meta value carrying the extension still resolves.
      const departmentCode = departmentItem?.department || "";
      return (
        departmentCode === valueAsText ||
        departmentItem?.departmentDescription === valueAsText ||
        String(departmentItem?.extension || "") === valueAsText
      );
    });

    // Resolve to the department CODE only (`department`). Never fall back to
    // the department name/label so `selectedDepartment === marker.department`
    // (a code comparison) stays consistent.
    const departmentCode =
      normalizedMeta?.department ||
      matchedDepartment?.department ||
      valueAsText;

    const departmentColor =
      normalizedMeta?.color || matchedDepartment?.color || "grey";

    return {
      name: departmentCode ? String(departmentCode) : "",
      color: departmentColor,
    };
  };

  // Sync with context-based department selection from Dispatcher toolbar
  useEffect(() => {
    if (!dispatcherDepartment?.value) {
      return;
    }
    const resolved = resolveDepartmentSelection(dispatcherDepartment.value, dispatcherDepartment.meta);
    selectedDepartmentRef.current = resolved.name || "";
    setSelectedDepartment(resolved.name || "");
    setDrawingColor(resolved.color || "grey");
  }, [dispatcherDepartment]);

  const rebuildDrawControl = (colorValue) => {
    if (!mapRef.current || !drawItemRef.current) return;

    const drawControl = new L.Control.Draw({
      position: "topright",
      edit: {
        featureGroup: drawItemRef.current,
        onCreated: _onCreated,
        onDeleted: _onDeleted,
      },
      draw: {
        rectangle: {
          shapeOptions: {
            color: colorValue,
            weight: 2,
            fillColor: colorValue,
            fillOpacity: 0.4,
          },
        },
        polygon: false,
        polyline: false,
        circle: false,
        marker: false,
        circlemarker: false,
      },
    });

    if (drawControlRef.current) {
      mapRef.current.removeControl(drawControlRef.current);
    }
    mapRef.current.addControl(drawControl);
    drawControlRef.current = drawControl;
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  useEffect(() => {
    localStorage.setItem("Show-Area", showArea);
  }, [showArea]);

  useEffect(() => {
    localStorage.setItem("Show-Route", showRoute);
  }, [showRoute]);

  useEffect(() => {
    var currentSelectionColor = "grey";
    if (ivrExtension?.code) {
      setSelectedDepartment(ivrExtension.code.department);
      currentSelectionColor = ivrExtension.code.color || "grey";
      setDrawingColor(currentSelectionColor);
    }

    if (mapRef.current != null && drawItemRef.current) {
      rebuildDrawControl(currentSelectionColor);
    }
  }, [ivrExtension]);

  useEffect(() => {
    if (mapRef.current && drawItemRef.current) {
      rebuildDrawControl(drawingColor || "grey");
    }
  }, [drawingColor]);

  useEffect(() => {
    getDropdownList();
  }, []);

  const { data: geofenceListData } = useGetAllGeofencesQuery();

  // Redraw ("resize") of an existing fence, triggered from the geofence panel.
  const geofenceDispatch = useDispatch();
  const { enqueueSnackbar: enqueueGeofenceSnackbar } = useSnackbar();
  const redrawGeofence = useSelector((state) => state.geofenceUi.redrawGeofence);
  const [updateGeofence] = useUpdateGeofenceMutation();
  const redrawTargetRef = useRef(null);

  useEffect(() => {
    if (!savedGeofenceLayerRef.current) return;

    savedGeofenceLayerRef.current.clearLayers();

    (geofenceListData || []).forEach((geofence) => {
      const color = geofence.color || "#3388ff";
      let layer = null;

      if (geofence.shapeType === "CIRCLE" && geofence.centerLat && geofence.centerLng) {
        layer = L.circle(
          [Number(geofence.centerLat), Number(geofence.centerLng)],
          {
            radius: geofence.radiusMeters || 0,
            color,
            fillColor: color,
            fillOpacity: 0.25,
          },
        );
      } else if (geofence.coordinates?.length) {
        const latLngs = geofence.coordinates.map((point) => [
          Number(point.lat),
          Number(point.lng),
        ]);
        layer = L.polygon(latLngs, { color, fillColor: color, fillOpacity: 0.25 });
      }

      if (layer) {
        layer.bindPopup(geofence.name || "Geofence");
        if (geofence.name) {
          // Always-visible name label centered on the fence
          layer.bindTooltip(geofence.name, {
            permanent: true,
            direction: "center",
            className: "geofence-name-label",
            opacity: 0.9,
          });
        }
        savedGeofenceLayerRef.current.addLayer(layer);
      }
    });
  }, [geofenceListData, map]);

  // leaflet-draw's toolbar action links (Finish / Delete last point / Cancel)
  // respond to mouse clicks but not to touch taps. While a geofence draw is
  // active, translate a tap on one of those links into a real click so the
  // buttons work on touch devices too.
  useEffect(() => {
    if (!geofenceDrawActive) return undefined;

    const handleActionTouch = (e) => {
      const link =
        e.target &&
        e.target.closest &&
        e.target.closest(".leaflet-draw-actions a");
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      link.click();
    };

    document.addEventListener("touchend", handleActionTouch, true);
    return () => document.removeEventListener("touchend", handleActionTouch, true);
  }, [geofenceDrawActive]);

  // When the panel requests a resize/redraw, remember the target fence and turn
  // on the draw tool; _onGeofenceCreated then saves onto the existing fence.
  useEffect(() => {
    if (!redrawGeofence || !mapRef.current || !geofenceDrawItemRef.current) return;
    redrawTargetRef.current = redrawGeofence;
    if (!geofenceDrawModeRef.current) {
      toggleGeofenceDrawTool();
    }
    // eslint-disable-next-line
  }, [redrawGeofence]);

  // Sync fullscreen state when user presses Escape or browser exits fullscreen
  useEffect(() => {
    const handler = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, []);

  useEffect(() => {
    selectedDepartmentRef.current = selectedDepartment;
  }, [selectedDepartment]);

  const { refetch } = useQuery(
    ["geoTags", selectedDepartment, isDrawing],
    async () => {
      if (!isDrawing) {
        const departmentList = selectedDepartment
          ? [selectedDepartment]
          : department;
        const response = await telemetry.post(
          `/geoTagging/list`,
         { "departmentList" : departmentList },
        );
        loggerFactory.debug(componentName, "Data tagging Received");
        setData(response.data.data);
        if (showArea) {
          const area = await application.post("/userZone/listAll");
          loggerFactory.debug(componentName, "Area Data Received");
          setAreaData(area.data.data);
        }
        if (showRoute) {
          const route = await telemetry.get("/route/listAll");
          loggerFactory.debug(componentName, "Route Data Received");
          setRouteData(route.data.data);
        }
      }
    },
    {
      refetchInterval: window.updateGeoTaggingList
        ? window.updateGeoTaggingList
        : 5000,
    },
  );

  useEffect(() => {
    if (searchText) {
      setFilteredList(
        data.filter(
          (item) =>
            item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.designation
              ?.toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.extensionNumber?.includes(searchText),
        ),
      );
    } else {
      setFilteredList(data);
    }
  }, [searchText, data]);

  useEffect(() => {
    if (filteredList.length === 1) {
      mapRef?.current?.setView(
        [filteredList[0].geoX, filteredList[0].geoY],
        zoomLevel,
      );
    }
  }, [filteredList, searchText]);

  useEffect(() => {
    if (!mapRef.current && mapContainerRef?.current) {
      const missingValues = [];
      const isValidLatLng =
        Array.isArray(homeLocation) &&
        typeof homeLocation[0] === "number" &&
        typeof homeLocation[1] === "number" &&
        !isNaN(homeLocation[0]) &&
        !isNaN(homeLocation[1]);
      const center = isValidLatLng ? homeLocation : [28.6139, 77.209];
      if (!isValidLatLng) {
        missingValues.push("Home Location");
      }

      const map = L.map(mapContainerRef.current, {
        minZoom: mapMinZoom,
        maxZoom: mapMaxZoom,
        zoomControl: false,
      }).setView(center, mapDefaultZoom);

      mapRef.current = map;
      if (
        typeof mapURL === "string" &&
        mapURL.trim() !== "" &&
        mapURL !== "null"
      ) {
        const initialBaseLayer =
          mapMode === "satellite"
            ? L.tileLayer(
                `${urlScheme}//${mapURL}/tile/{z}/{y}/{x}.png`,
                {
                  attribution:
                    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                },
              )
            : L.tileLayer(`${urlScheme}//${mapURL}/tile/{z}/{x}/{y}.png`, {
                attribution:
                  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
              });

        initialBaseLayer.addTo(map);
        tileLayerRef.current = initialBaseLayer;
        setMap(map);
      } else {
        missingValues.push("Map URL");
      }

     
      const drawnItems = new L.FeatureGroup();
      drawItemRef.current = drawnItems;

      map.addLayer(drawnItems);

      const geofenceDrawnItems = new L.FeatureGroup();
      geofenceDrawItemRef.current = geofenceDrawnItems;
      map.addLayer(geofenceDrawnItems);

      const savedGeofenceLayer = new L.FeatureGroup();
      savedGeofenceLayerRef.current = savedGeofenceLayer;
      map.addLayer(savedGeofenceLayer);

      map.on("draw:created", _onGeofenceCreated);

      rebuildDrawControl(drawingColor || "grey");
      map.on("draw:drawstart", () => {
        setIsDrawing(true);
      });

      map.on("draw:drawstop", () => {
        setIsDrawing(false);
      });
      map.on("draw:created", _onCreated);
      map.on("draw:deleted", _onDeleted);
      map.on("draw:editstop", () => {
        setIsDrawing(false);
        editHandlerRef.current = null;
      });
      map.on("draw:drawstart", function (e) {
        drawnItems.clearLayers();
        setHasDrawnShape(false);
      });

      map.on("zoomend", () => {
        const currentZoom = map.getZoom();
        console.log("Zoom level changed to:", currentZoom);
        setZoomLevel(currentZoom);
      });

      map.on("draw:created", function (e) {
        setIsDrawing(false);
        const type = e.layerType;
        const layer = e.layer;

        if (type === "rectangle") {
          const bounds = layer.getBounds();
          const topLeft = bounds.getNorthWest();
          const topRight = bounds.getNorthEast();
          const bottomLeft = bounds.getSouthWest();
          const bottomRight = bounds.getSouthEast();

          loggerFactory.debug("Rectangle corners:");
          loggerFactory.debug(
            componentName,
            "Corner 1 (Top Left): " + topLeft.lat + ", " + topLeft.lng,
          );
          loggerFactory.debug(
            componentName,
            "Corner 2 (Top Right): " + topRight.lat + ", " + topRight.lng,
          );
          loggerFactory.debug(
            componentName,
            "Corner 3 (Bottom Right): " +
              bottomRight.lat +
              ", " +
              bottomRight.lng,
          );
          loggerFactory.debug(
            componentName,
            "Corner 4 (Bottom Left): " + bottomLeft.lat + ", " + bottomLeft.lng,
          );

          drawnItems.addLayer(layer);
          setHasDrawnShape(true);
        }
      });

      if (missingValues.length > 0) {
        setNotify({
          isOpen: true,
          message: `Some values are missing: ${missingValues.join(", ")}`,
          type: "error",
          pagename: componentName,
          status: "Map initialized with default/fallback values",
        });
      }
    }
  }, [homeLocation, mapDefaultZoom, isDrawing]);

  useEffect(() => {
    if (mapRef.current && data && userPaths?.length === 0) {
      mapRef.current.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          mapRef.current.removeLayer(layer);
        }
      });

      const markers = L.layerGroup().addTo(mapRef.current);
      const markerDataMap = new Map();
      const calculateDragDistance = (latlng1, latlng2) =>
        latlng1.distanceTo(latlng2);

      const handleDragEnd = (event) => {
        const draggedMarker = event.target;
        const draggedMarkerPosition = draggedMarker.getLatLng();
        const draggedMarkerData = markerDataMap.get(draggedMarker);

        if (!draggedMarkerData) {
          loggerFactory.warn(
            componentName,
            "handleDragEnd: dragged marker data not found",
          );
          return;
        }

        draggedMarkerData.geoX = draggedMarkerPosition.lat;
        draggedMarkerData.geoY = draggedMarkerPosition.lng;
        refetch();

        let nearestMarker = null;
        let nearestDistance = Infinity;

        for (const layer of markers.getLayers()) {
          if (layer instanceof L.Marker && layer !== draggedMarker) {
            const markerPosition = layer.getLatLng();
            const distance = calculateDragDistance(
              draggedMarkerPosition,
              markerPosition,
            );
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestMarker = layer;
            }
          }
        }

        if (!nearestMarker) {
          setNotify({
            isOpen: true,
            message: "",
            type: "warning",
            pagename: componentName,
            status: "No other marker found to transfer the call.",
          });
          return;
        }

        const droppedOnMarkerData = markerDataMap.get(nearestMarker);

        if (nearestDistance > 150) {
          setNotify({
            isOpen: true,
            message: "",
            type: "warning",
            pagename: componentName,
            status:
              "Drop the marker closer to another marker to transfer the call.",
          });
          return;
        }

        dragToCall(draggedMarkerData, droppedOnMarkerData);
        loggerFactory.info(
          componentName,
          `marker dragged data: ${JSON?.stringify(draggedMarkerData)}`,
        );
        loggerFactory.info(
          componentName,
          `marker dropped data: ${JSON?.stringify(droppedOnMarkerData)}`,
        );
      };

      function convertEpochToDateTime(epoch) {
        const date = new Date(epoch * 1000);
        const formattedDate = date.toLocaleDateString("en-GB");
        const formattedTime = date.toLocaleTimeString("en-US");
        return `${formattedDate}, ${formattedTime}`;
      }

      const createPopupContent = (marker, allMarkers) => {
        const { geoX, geoY, data } = marker;
        const markerExtension =
          marker?.extensionNumber || marker?.extension || marker?.offEXtn || marker?.number || "";
        const lastUpdateTime = marker?.updatedOn
          ? new Date(marker.updatedOn)
          : null;
        const currentTime = new Date();
        const timeDifference = lastUpdateTime
          ? (currentTime - lastUpdateTime) / (1000 * 60)
          : 0;

        const batteryStatus = marker?.batteryPercentage || 0;
        const isNotRegistered = marker?.registeredStatus !== "Registered";

        let statusMessage = "";
        if (timeDifference > 15 && batteryStatus < 5) {
          statusMessage = "Battery Low";
        } else if (marker?.rsRpSim1 < -120 && isNotRegistered) {
          statusMessage = "Signal Loss";
        } else {
          statusMessage = "Unknown Reason";
        }

        const battery = marker?.batteryPercentage > 0 ? marker.batteryPercentage : 0;
        const batteryColor = battery > 60 ? "#22c55e" : battery > 20 ? "#f59e0b" : "#ef4444";
        const batteryWidth = Math.max(battery, 3);

        const infoRows = data ? [
          ["📍", `${geoX}, ${geoY}`],
          ["🩸", data?.bloodGroup || "N/A"],
          ["🏥", data?.medicalDetails || "N/A"],
          ["🏠", data?.homeAddress || "N/A"],
          ["🏢", data?.officeAddress || "N/A"],
          ["📞", `${data?.primaryEmergencyContactName || "N/A"} ${data?.primaryEmergencyContactNumber || ""}`],
          ["📞", `${data?.secondaryEmergencyContactName || "N/A"} ${data?.secondaryEmergencyContactNumber || ""}`],
        ] : [
          ["📍", `${geoX}, ${geoY}`],
        ];

        const infoHTML = infoRows.map(([icon, value]) => `
          <div style="display:flex;align-items:flex-start;gap:5px; 0;font-size:10.5px;color:#334155;">
            <span style="flex-shrink:0;">${icon}</span>
            <span style="word-break:break-word;">${value}</span>
          </div>`).join("");

        const warningBadge = !marker?.registered
          ? `<span style="background:#fef9c3;color:#854d0e;border-radius:20px;padding:1px 7px;font-size:9px;font-weight:600;margin-left:6px;">⚠️ ${statusMessage}</span>`
          : "";

        const btnStyle = (bg) => `background:${bg};color:#fff;border:none;border-radius:5px;padding:4px 8px;font-size:10.5px;font-weight:600;cursor:pointer;flex:1;`;

        const sosClearBtn = marker.emergencyStatus
          ? `<div style="padding:4px 10px 6px;background:#fff3f3;"><button onclick="window.handleClearEmergency('${marker.extensionNumber}')" style="width:100%;background:#dc2626;color:#fff;border:none;border-radius:5px;padding:5px;font-size:11px;font-weight:700;cursor:pointer;">Clear SOS</button></div>`
          : "";

        return `
        <div style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;min-width:220px;max-width:260px;padding:0;border-radius:10px;overflow:hidden;">
          <!-- Header: name + ext + battery inline -->
          <div style="background:linear-gradient(135deg,#1e3a5f 0%,#1356c2 100%);padding:8px 10px;color:#fff;">
            <div style="display:flex;align-items:center;justify-content:space-between;gap:6px;">
              <div style="min-width:0;">
                <div style="font-size:12px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${marker?.designation || marker?.name || "—"}${warningBadge}</div>
                <div style="font-size:10px;opacity:.8;margin-top:1px;">📱 ${markerExtension}</div>
              </div>
              <div style="flex-shrink:0;text-align:right;">
                <div style="font-size:10px;color:rgba(255,255,255,0.7);margin-bottom:2px;">🔋 ${battery}%</div>
                <div style="width:52px;background:rgba(255,255,255,0.25);border-radius:99px;height:5px;overflow:hidden;">
                  <div style="width:${batteryWidth}%;height:100%;background:${batteryColor};border-radius:99px;"></div>
                </div>
                <div style="font-size:9px;color:rgba(255,255,255,0.55);margin-top:2px;">${convertEpochToDateTime(marker?.updatedOn)}</div>
              </div>
            </div>
          </div>

          <!-- Info -->
          <div style="padding:6px 10px;background:#fff;">
            ${infoHTML}
          </div>

          <!-- Action buttons -->
          <div style="background:#f8fafc;padding:6px 10px 8px;display:flex;gap:4px;">
            <button style="${btnStyle("#1356c2")}" onclick="window.clickToCallTrain('${markerExtension}')">Call</button>
            <button style="${btnStyle("#b45309")}" onclick="window.clickToVideoCallTrain('${markerExtension}')">Video</button>
            <button style="${btnStyle("#16a34a")}" onclick="window.clickToMessageMarker('${markerExtension}')">Message</button>
            <button style="${btnStyle("#b8251a")}" onclick="window.clickToMarkerAmbient('${markerExtension}')">Ambient</button>
          </div>
          ${sosClearBtn}
        </div>`;
      };
      // Registry + state for opening a marker's popup while another is dragged over it
      const miniMarkerRegistry = [];
      let activeDropTarget = null;
      const DRAG_OVER_THRESHOLD_PX = 42;

      if (userPaths?.length === 0) {
        filteredList.forEach((marker) => {
          if (marker.geoX && marker.geoY) {
            const markerLocation = [
              parseFloat(marker.geoX),
              parseFloat(marker.geoY),
            ];

            const customIcon = getMarkerIcon(marker);
            const customMarker = L.marker(markerLocation, {
              icon: customIcon,
              draggable: true,
            });

            markerDataMap.set(customMarker, marker);
            customMarker.addTo(markers);
            customMarker.on("dragend", handleDragEnd);

            // ── Mini drag/hover popups ──────────────────────────────────────
            const miniName =
              marker?.designation || marker?.name || marker?.userName || "—";
            const miniNumber =
              marker?.extensionNumber ||
              marker?.extension ||
              marker?.offEXtn ||
              marker?.number ||
              "";
            // variant: "info" => blue (drag), "success" => green (hover)
            const buildMiniContent = (variant) => {
              const bg = variant === "info" ? "#0288d1" : "#2e9e44";
              const border = variant === "info" ? "#0277bd" : "#2e7d32";
              return `
                <div style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;background:${bg};color:#fff;border:1px solid ${border};border-radius:6px;padding:4px 8px;min-width:64px;max-width:190px;box-shadow:0 2px 6px rgba(0,0,0,0.35);line-height:1.25;">
                  <div style="font-size:11px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${miniName}</div>
                  ${miniNumber
                  ? `<div style="font-size:10px;opacity:.92;margin-top:1px;white-space:nowrap;">📱 ${miniNumber}</div>`
                  : ""
                }
                </div>`;
            };

            const dragMiniPopup = L.popup({
              closeButton: false,
              autoClose: false,
              closeOnClick: false,
              autoPan: false,
              offset: [0, -12],
              className: "mini-marker-popup mini-marker-popup--info",
            });
            const hoverMiniPopup = L.popup({
              closeButton: false,
              autoClose: false,
              closeOnClick: false,
              autoPan: false,
              offset: [0, -12],
              className: "mini-marker-popup mini-marker-popup--success",
            });

            // Register this marker so other markers can open its popup on drag-over
            miniMarkerRegistry.push({
              marker: customMarker,
              popup: hoverMiniPopup,
              build: buildMiniContent,
            });

            // Drag popup (info/blue) follows the marker while dragging
            customMarker.on("dragstart", (e) => {
              mapRef.current?.closePopup(hoverMiniPopup);
              dragMiniPopup
                .setLatLng(e.target.getLatLng())
                .setContent(buildMiniContent("info"))
                .openOn(mapRef.current);
            });
            customMarker.on("drag", (e) => {
              dragMiniPopup.setLatLng(e.target.getLatLng());

              // Open the popup of the marker being dragged over (success/green)
              const activeMap = mapRef.current;
              if (!activeMap) return;
              const dragPoint = activeMap.latLngToLayerPoint(
                e.target.getLatLng(),
              );

              let nearest = null;
              let nearestDistance = Infinity;
              miniMarkerRegistry.forEach((entry) => {
                if (entry.marker === customMarker) return;
                const entryPoint = activeMap.latLngToLayerPoint(
                  entry.marker.getLatLng(),
                );
                const distance = dragPoint.distanceTo(entryPoint);
                if (distance < nearestDistance) {
                  nearestDistance = distance;
                  nearest = entry;
                }
              });

              if (nearest && nearestDistance <= DRAG_OVER_THRESHOLD_PX) {
                if (activeDropTarget && activeDropTarget !== nearest) {
                  activeMap.closePopup(activeDropTarget.popup);
                }
                if (activeDropTarget !== nearest) {
                  nearest.popup
                    .setLatLng(nearest.marker.getLatLng())
                    .setContent(nearest.build("success"))
                    .openOn(activeMap);
                  activeDropTarget = nearest;
                }
              } else if (activeDropTarget) {
                activeMap.closePopup(activeDropTarget.popup);
                activeDropTarget = null;
              }
            });
            customMarker.on("dragend", () => {
              mapRef.current?.closePopup(dragMiniPopup);
              if (activeDropTarget) {
                mapRef.current?.closePopup(activeDropTarget.popup);
                activeDropTarget = null;
              }
            });

            // Hover popup (success/green) — opens on hover, auto-closes on mouseout
            customMarker.on("mouseover", (e) => {
              hoverMiniPopup
                .setLatLng(e.target.getLatLng())
                .setContent(buildMiniContent("success"))
                .openOn(mapRef.current);
            });
            customMarker.on("mouseout", () => {
              mapRef.current?.closePopup(hoverMiniPopup);
            });

            customMarker.bindPopup(createPopupContent(marker, data), {
              autoClose: false,
            });
            customMarker.on("popupopen", () => {
              setIsDrawing(true);
              window.handleTransferCall(marker.userCoordinateId);
            });

            customMarker.on("popupclose", () => {
              setIsDrawing(false);
              setSelectedMarkerTransferCall({ select: {}, number: {} });
            });
          }
        });
      }
    }
  }, [filteredList, selectedDepartment, showSelect, userPaths]);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.eachLayer((layer) => {
        if (layer.options && layer.options.className === "area-layer") {
          mapRef.current.removeLayer(layer);
        }
        if (layer.options && layer.options.className === "route-layer") {
          mapRef.current.removeLayer(layer);
        }
      });

      if (areaData && showArea) {
        areaData.forEach((shape) => {
          if (shape.coordinates && Array.isArray(shape.coordinates)) {
            const coordinates = shape.coordinates.map((coord) => [
              parseFloat(coord.lng),
              parseFloat(coord.lat),
            ]);
            const polygon = L.polygon(coordinates, {
              color: "blue",
              weight: 2,
              fillOpacity: 0.2,
              className: "area-layer",
            }).addTo(mapRef.current);

            polygon.bindPopup(`<b>${shape.name}</b>`);
            areaLayer.addLayer(polygon);
          } else {
            console.warn(`Invalid coordinates for area:`, shape);
          }
        });
      }

      if (routeData && showRoute) {
        routeData.forEach((route) => {
          if (route.coordinates && Array.isArray(route.coordinates)) {
            const coordinates = route.coordinates.map((coord) => [
              parseFloat(coord.latitude),
              parseFloat(coord.longitude),
            ]);

            if (coordinates.length >= 2) {
              const polyline = L.polyline(coordinates, {
                color: "red",
                weight: 3,
                fillOpacity: 0.1,
                className: "route-layer",
              }).addTo(mapRef.current);

              const startPoint = coordinates[0];
              L.circleMarker(startPoint, {
                color: "green",
                radius: 6,
                fillColor: "green",
                className: "route-layer",
                fillOpacity: 1,
              })
                .addTo(mapRef.current)
                .bindPopup("Start Point", {
                  permanent: true,
                  direction: "right",
                });

              const endPoint = coordinates[coordinates.length - 1];
              L.circleMarker(endPoint, {
                color: "red",
                radius: 6,
                fillColor: "red",
                className: "route-layer",
                fillOpacity: 1,
              })
                .addTo(mapRef.current)
                .bindPopup("End Point", { permanent: true, direction: "left" });

              const arrowDecorator = L.polylineDecorator(polyline, {
                patterns: [
                  {
                    offset: 25,
                    repeat: 50,
                    symbol: L.Symbol.arrowHead({
                      pixelSize: 10,
                      polygon: false,
                      pathOptions: {
                        stroke: true,
                        color: "red",
                        weight: 2,
                      },
                    }),
                  },
                ],
                className: "route-layer",
              });
              arrowDecorator.addTo(mapRef.current);

              polyline.bindPopup(`<b>${route.name}</b>`);
              routeLayer.addLayer(polyline);
            } else {
              console.warn(`Route must have at least two coordinates:`, route);
            }
          } else {
            console.warn(`Invalid coordinates for route:`, route);
          }
        });
      }
    }
  }, [areaData, routeData, showArea, showRoute]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    if (!userPaths || userPaths.length === 0) return;

    // --- Remove old markers before drawing new ones ---
    map.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        map.removeLayer(layer);
      }
    });

    const user = userPaths[0];
    const sortedPath = [...user.location].sort(
      (a, b) => a.timestamp - b.timestamp,
    );
    if (sortedPath.length < 2) return;

    // Convert to [lat, lng] pairs and handle timestamp conversion (seconds → ms)
    const latlngs = sortedPath.map((p) => [
      parseFloat(p.latitude),
      parseFloat(p.longitude),
    ]);
    const timestamps = sortedPath.map((p) => p.timestamp * 1000);

    // --- Draw route line ---
    const polyline = L.polyline(latlngs, {
      color: "blue",
      weight: 4,
      opacity: 0.8,
      className: "user-route-layer",
    }).addTo(map);

    // --- Hover popup for time ---
    const timePopup = L.popup({
      closeButton: false,
      autoClose: true,
      className: "time-popup",
    });

    // ✅ Show dynamic time popup when hovering on route
    polyline.on("mousemove", (e) => {
      const { lat, lng } = e.latlng;

      // find nearest point
      let closestIdx = 0;
      let minDist = Infinity;

      latlngs.forEach((pt, idx) => {
        const d = Math.hypot(pt[0] - lat, pt[1] - lng);
        if (d < minDist) {
          minDist = d;
          closestIdx = idx;
        }
      });

      const time = new Date(timestamps[closestIdx]).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      timePopup
        .setLatLng(e.latlng)
        .setContent(`<b>Time:</b> ${time}`)
        .openOn(map);
    });

    polyline.on("mouseout", () => {
      map.closePopup(timePopup);
    });

    // --- Start & End markers ---
    L.circleMarker(latlngs[0], {
      color: "green",
      fillColor: "green",
      fillOpacity: 1,
      radius: 6,
      className: "user-route-layer",
    })
      .addTo(map)
      .bindPopup(
        `<b>${user.userName} Start Point</b><br/>Time: ${new Date(
          timestamps[0],
        ).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}`,
      );

    L.circleMarker(latlngs[latlngs.length - 1], {
      color: "red",
      fillColor: "red",
      fillOpacity: 1,
      radius: 6,
      className: "user-route-layer",
    })
      .addTo(map)
      .bindPopup(
        `<b>${user.userName} End Point</b><br/>Time: ${new Date(
          timestamps[timestamps.length - 1],
        ).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}`,
      );

    // --- Moving marker ---
    const initialIcon = L.icon({
      iconUrl: "/images/man-east.png",
      iconSize: [32, 32],
      iconAnchor: [16, 16],
    });

    const marker = L.marker(latlngs[0], {
      icon: initialIcon,
      className: "user-route-layer",
      opacity: 1,
    }).addTo(map);

    markerRefs.current[user.userName] = marker;
    indexRefs.current[user.userName] = 0;

    // --- Animation loop ---
    const interval = setInterval(() => {
      let i = indexRefs.current[user.userName];
      if (i >= latlngs.length - 1) {
        clearInterval(interval);
        indexRefs.current[user.userName] = latlngs.length - 1;

        if (isMarkerVisible.current) {
          const hideTimeout = setTimeout(() => {
            marker.setOpacity(0);
            isMarkerVisible.current = false;
          }, 5000);
          timeoutRefs.current[user.userName] = hideTimeout;
        }
        return;
      }

      i++;
      indexRefs.current[user.userName] = i;
      marker.setLatLng(latlngs[i]);

      const prev = latlngs[i - 1];
      const curr = latlngs[i];
      const heading =
        Math.atan2(curr[1] - prev[1], curr[0] - prev[0]) * (180 / Math.PI);

      let direction = "east";
      if (heading > 45 && heading <= 135) direction = "north";
      else if (heading > 135 || heading <= -135) direction = "west";
      else if (heading > -135 && heading <= -45) direction = "south";

      marker.setIcon(
        L.icon({
          iconUrl: `/images/man-${direction}.png`,
          iconSize: [32, 32],
          iconAnchor: [16, 16],
        }),
      );
    }, 350);

    intervalRefs.current[user.userName] = interval;

    // --- Control panel ---
    const controlDiv = L.DomUtil.create("div", "user-path-control");
    controlDiv.style.cssText = `
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    background: rgba(255,255,255,0.95);
    border-radius: 8px;
    padding: 8px 16px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.25);
    font-size: 14px;
  `;
    controlDiv.innerHTML = `
    <b>User Path: ${user.userName}</b> &nbsp;
    <button id="restart-route-${user.userName}" style="cursor:pointer">🔁</button>
    <button id="close-route-${user.userName}" style="cursor:pointer">⛔</button>
  `;
    map.getContainer().appendChild(controlDiv);

    // --- Restart handler ---
    const restartHandler = () => {
      clearInterval(intervalRefs.current[user.userName]);
      clearTimeout(timeoutRefs.current[user.userName]);
      marker.setOpacity(1);
      isMarkerVisible.current = true;
      indexRefs.current[user.userName] = 0;
      marker.setLatLng(latlngs[0]);

      const newInterval = setInterval(() => {
        let i = indexRefs.current[user.userName];
        if (i >= latlngs.length - 1) {
          clearInterval(newInterval);
          indexRefs.current[user.userName] = latlngs.length - 1;
          if (isMarkerVisible.current) {
            const hideTimeout = setTimeout(() => {
              marker.setOpacity(0);
              isMarkerVisible.current = false;
            }, 5000);
            timeoutRefs.current[user.userName] = hideTimeout;
          }
          return;
        }

        i++;
        indexRefs.current[user.userName] = i;
        marker.setLatLng(latlngs[i]);

        const prev = latlngs[i - 1];
        const curr = latlngs[i];
        const heading =
          Math.atan2(curr[1] - prev[1], curr[0] - prev[0]) * (180 / Math.PI);
        let direction = "east";
        if (heading > 45 && heading <= 135) direction = "north";
        else if (heading > 135 || heading <= -135) direction = "west";
        else if (heading > -135 && heading <= -45) direction = "south";

        marker.setIcon(
          L.icon({
            iconUrl: `/images/man-${direction}.png`,
            iconSize: [32, 32],
            iconAnchor: [16, 16],
          }),
        );
      }, 350);
      intervalRefs.current[user.userName] = newInterval;
    };

    // --- Close handler ---
    const closeHandler = () => {
      clearInterval(intervalRefs.current[user.userName]);
      clearTimeout(timeoutRefs.current[user.userName]);
      map.eachLayer((layer) => {
        if (layer.options?.className === "user-route-layer") {
          map.removeLayer(layer);
        }
      });
      controlDiv.remove();
      delete markerRefs.current[user.userName];
      delete intervalRefs.current[user.userName];
      delete timeoutRefs.current[user.userName];
      delete indexRefs.current[user.userName];
      delete userStatus.current[user.userName];
      setUserPaths([]);
    };

    // Attach handlers
    const restartButton = document.getElementById(
      `restart-route-${user.userName}`,
    );
    const closeButton = document.getElementById(`close-route-${user.userName}`);
    restartButton?.addEventListener("click", restartHandler);
    closeButton?.addEventListener("click", closeHandler);

    // --- Cleanup ---
    return () => {
      clearInterval(intervalRefs.current[user.userName]);
      clearTimeout(timeoutRefs.current[user.userName]);
      map.eachLayer((layer) => {
        if (layer.options?.className === "user-route-layer") {
          map.removeLayer(layer);
        }
      });
      controlDiv.remove();
      restartButton?.removeEventListener("click", restartHandler);
      closeButton?.removeEventListener("click", closeHandler);
      delete markerRefs.current[user.userName];
      delete intervalRefs.current[user.userName];
      delete timeoutRefs.current[user.userName];
      delete indexRefs.current[user.userName];
      delete userStatus.current[user.userName];
    };
  }, [userPaths, mapRef.current]);

  function renderIconWithColor(color, size) {
    return divIcon({
      html: renderToStaticMarkup(
        <FmdGood style={{ color: color }} fontSize="large" />,
      ),
    });
  }

  const iconIMSIActive = renderToStaticMarkup(
    <FmdGood color="success" fontSize="large" />,
  );

  const pin = renderToStaticMarkup(
    <MyLocationIcon color="info" fontSize="small" />,
  );

  const iconIMSIEmergency = renderToStaticMarkup(
    <LocalHospital color="error" fontSize="large" />,
  );

  const iconIMSIInActive = renderToStaticMarkup(
    <FmdGood color="warning" fontSize="large" />,
  );

  const iconEnemy = renderToStaticMarkup(
    <FmdBad color="warning" fontSize="large" />,
  );

  let icon = iconIMSIActive;
  const markerIMSIActive = divIcon({
    html: icon,
  });
  const markerIMSIInActive = divIcon({
    html: iconIMSIInActive,
  });
  const markerEnemy = divIcon({
    html: iconEnemy,
  });

  const markerEmergency = divIcon({
    html: iconIMSIEmergency,
  });

  window.dragCallTransfer = (extensionNumber) => {
    console.log("Drag Call event data send : ", extensionNumber);
    window?.chrome?.webview?.postMessage(
      JSON.stringify({
        eventType: "Drag and Drop Call",
        data: extensionNumber,
      }),
    );
    mapRef?.current?.closePopup();
  };
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  window.handleTransferCall = (clickedMarkerId) => {
    const clickedMarker = data.find(
      (marker) => marker.userCoordinateId === parseInt(clickedMarkerId),
    );
    const sortedMarkers = data
      .filter(
        (marker) =>
          marker.userCoordinateId !== clickedMarker.userCoordinateId &&
          marker.geoX &&
          marker.geoY,
      )
      .map((marker) => ({
        ...marker,
        distance: calculateDistance(
          parseFloat(clickedMarker.geoX),
          parseFloat(clickedMarker.geoY),
          parseFloat(marker.geoX),
          parseFloat(marker.geoY),
        ),
      }))
      .sort((a, b) => a.distance - b.distance);
    setNearestMarkers(sortedMarkers);
    setShowSelect(true);
  };

  window.handleSelectChange = (e, marker) => {
    try {
      const markerData = JSON.parse(decodeURIComponent(marker));
      const selectedMarker = nearestMarkers.find(
        (marker) => marker.extensionNumber === e.target.value,
      );
      setSelectedMarkerTransferCall({
        select: selectedMarker,
        marker: markerData,
      });
    } catch (error) {
      console.error("Error parsing marker data:", error);
    }
  };

  window.transferCallSelectedMarker = () => {
    const { select, marker } = selectedMarkerTransferCall;
    if (
      select &&
      Object.keys(select).length > 0 &&
      marker &&
      Object.keys(marker).length > 0
    ) {
      mapRef?.current?.closePopup();
      dragToCall(marker, select);
    } else {
      setNotify({
        isOpen: true,
        message: "",
        type: "warning",
        pagename: componentName,
        status: "Please select any marker to transfer call",
      });
    }
  };

  const makeMarkerContactPayload = (number) => ({
    offEXtn: number,
    extension: number,
    number,
  });

  window.clickToCallTrain = (number) => {
    console.log("click to call event data send : ", number);
    const contactPayload = makeMarkerContactPayload(number);

    if (typeof onContactAction === "function") {
      onContactAction("call", contactPayload);
      return;
    }

    setClickToCall(dispatch, number);
  };

  window.clickToVideoCallTrain = (number) => {
    console.log("click to video call event data send : ", number);
    const contactPayload = makeMarkerContactPayload(number);

    if (typeof onContactAction === "function") {
      onContactAction("video-call", contactPayload);
      return;
    }

    setClickToVideoCall(dispatch, number);
  };

  window.clickToMessageMarker = (number) => {
    const contactPayload = makeMarkerContactPayload(number);

    if (typeof onContactAction === "function") {
      onContactAction("message", contactPayload);
      return;
    }

    setSelectedMarker(number);
    setOpen(true);
  };

  window.clickToAccessMarker = (number) => {
    const body = {
      fromUser: UserNumber,
      toUser: number,
    };
    application
      .post("/user/accessControl", body)
      .then((response) => {
        setNotify({
          isOpen: true,
          message: "",
          type: "success",
          pagename: componentName,
          status: "Requesting to Selected Device Camera-Mic Access",
        });
        activityLog(
          "event",
          "Device Access",
          "Camera-Mic Access",
          UserNumber,
          number,
          `${userName} access camera and mic ${UserNumber} to ${number}`,
        );
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: "",
          type: "error",
          pagename: componentName,
          status: "Unable to Access Selected Device Camera-Mic",
        });
      });
  };

  window.clickToMarkerAmbient = (number) => {
    const contactPayload = makeMarkerContactPayload(number);

    if (typeof onContactAction === "function") {
      onContactAction("ambient-mode", contactPayload);
      return;
    }

    const payload = {
      kind: "D",
      sender: AuthenticationService.getExtensionNumber(),
      target: number,
      content: `callType: Ambient; callState: RequestAmbient;`,
      messageType: "call",
    };
    setAmbientMode(dispatch, true);
    telemetry.post("chat/message", payload);
    setSelectedMarker(null);
    setNotify({
      isOpen: true,
      type: "info",
      pagename: "Map",
      status: `Please wait... Ambient mode request sent to ${number}`,
    });
  };


  const extractRoomId = (eventContent) => {
    if (!eventContent) return "";
    const roomIdMatch = eventContent.match(/roomId\s*[:=]\s*([^;\s]+)/i);
    return roomIdMatch?.[1]?.trim() || "";
  };


  const dragToCall = (draggedMarkerData, droppedOnMarkerData) => {
    const activeEvent = dragAndDropEventRef.current || dragAndDropEvent;

    if (!activeEvent) {
      setNotify({
        isOpen: true,
        message: "",
        type: "warning",
        pagename: componentName,
        status: "Please drag a marker with an active SOS call.",
      });
      return;
    }

    if (dragAndDropEvent?.sender!== draggedMarkerData.extensionNumber) {
      setNotify({
        isOpen: true,
        message: "",
        type: "warning",
        pagename: componentName,
        status: "Please drag Active SOS call marker.",
      });
      return;
    }

    setNotify({
      isOpen: true,
      message: "",
      type: "success",
      pagename: componentName,
      status: `Drag & Drop Calling for : ${droppedOnMarkerData.extensionNumber}`,
    });

    const roomId =
      activeEvent?.roomId || extractRoomId(activeEvent?.content) || "";
    const payload = {
      kind: "D",
      sender: AuthenticationService.getExtensionNumber(),
      target: draggedMarkerData.extensionNumber,
      content: `roomId: ${roomId}; type: video; callType: DragAndDrop; callState: Connecting; calledTo: ${droppedOnMarkerData.extensionNumber}`,
      messageType: "call",
    };

    telemetry.post("chat/message", payload);
  };

  window.handleClearEmergency = async (imsi) => {
    try {
      const response = await telemetry.post(
        `/geoTagging/clearEmergency/${imsi}`,
      );
      setNotify({
        isOpen: true,
        message: "",
        type: "success",
        pagename: componentName,
        status: "SOS Clear Successfully",
      });
      mapRef?.current?.closePopup();
      refetch();
    } catch (error) {
      setNotify({
        isOpen: true,
        message: "",
        type: "error",
        pagename: componentName,
        status: "Failed to clear emergency",
      });

      console.error("Error clearing emergency:", error);
    }
  };

  window.handlePinDelete = (id) => {
    telemetry.post(`/geoTagging/delete/${id}`);
  };

  // ── Map control handlers ──────────────────────────────────────────────────

  const handleZoomIn = () => mapRef.current?.zoomIn();
  const handleZoomOut = () => mapRef.current?.zoomOut();

  const handleResetView = () => {
    if (mapRef.current) {
      const center = Array.isArray(homeLocation) ? homeLocation : [28.6139, 77.209];
      mapRef.current.setView(center, mapDefaultZoom);
    }
  };

  const handleToggleFullscreen = () => {
    const container = mapContainerRef.current;
    if (!container) return;
    if (!document.fullscreenElement) {
      container.requestFullscreen?.();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen?.();
      setIsFullscreen(false);
    }
  };

  const handleToggleMapMode = () => {
    if (!mapRef.current) return;
    const map = mapRef.current;

    // Remove current tile layer
    if (tileLayerRef.current) {
      map.removeLayer(tileLayerRef.current);
      tileLayerRef.current = null;
    }

    if (mapMode === "standard") {
      // Switch to satellite
      const satellite = L.tileLayer(
        `${urlScheme}//${mapURL}/tile/{z}/{y}/{x}.png`,
        { attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' }
      );
      satellite.addTo(map);
      tileLayerRef.current = satellite;
      setMapMode("satellite");
    } else {
      // Switch back to standard OSM
      const osm = L.tileLayer(
        `${urlScheme}//${mapURL}/tile/{z}/{x}/{y}.png`,
        { attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' }
      );
      osm.addTo(map);
      tileLayerRef.current = osm;
      setMapMode("standard");
    }
  };

  const handleToggleLabels = () => {};

  const handleToggleStreetView = () => {
    setIsStreetViewMode((prev) => {
      const next = !prev;
      if (next && mapRef.current) {
        // One-shot click handler to open Google Street View
        const onMapClick = (e) => {
          const { lat, lng } = e.latlng;
          window.open(
            `https://www.google.com/maps?q=&layer=c&cbll=${lat},${lng}`,
            "_blank"
          );
          mapRef.current.off("click", onMapClick);
          setIsStreetViewMode(false);
        };
        mapRef.current.once("click", onMapClick);
      } else if (!next && mapRef.current) {
        mapRef.current.off("click");
      }
      return next;
    });
  };

  // ─────────────────────────────────────────────────────────────────────────

  const getDropdownList = () => {
    application
      .post("extensions/listAllZone")
      .then((response) => {
        setZoneList(response.data.data);
      })
      .catch((error) => {
        console.error("Failed to get Zone data-", error);
      });
  };

  const getFileList = () => {
    application
      .post("announcement/listAll")
      .then((response) => {
        setFileList(response.data.data);
      })
      .catch((error) => {
        console.error("Failed to get data-", error);
      });
  };

  const announcementClick = (name) => {
    setSelectedZone(true);
    setClickButtonName(name);
    getDropdownList();
  };

  const recordingAnnouncementClick = (name) => {
    setSelectedZone(true);
    setClickButtonName(name);
    getDropdownList();
  };

  const pageClick = (name) => {
    setSelectedZone(true);
    setClickButtonName(name);
    getDropdownList();
    getFileList();
  };

  const groupCallClick = (name) => {
    setSelectedZone(true);
    setClickButtonName(name);
    getDropdownList();
  };

  const messageClick = (name) => {
    setClickButtonName(name);
    setSelectedZone(true);
    getDropdownList();
  };

  const onEmergencyClick = () => {
    const number = AuthenticationService.getPublicEmergencyNumber();
    if (number) {
      if (window.disablePhone) {
        console.log("Public Emergency event data send : ", number);
        window.chrome.webview.postMessage(
          JSON.stringify({
            eventType: "PublicEmergency",
            data: number,
          }),
        );
      } else {
        setIsPublicEmergencyCall(dispatch, true);
        setClickToCall(dispatch, number);
      }
    } else {
      setNotify({
        isOpen: true,
        message: "",
        type: "info",
        pagename: componentName,
        status: "Please Define Public Emergency Number",
      });
    }
  };

  const onCloseForm = () => {
    setSelectedZone(false);
    setIsZDValid(true);
    setIsFileValid(true);
    setIsMessageValid(true);
    setMessageToBroadcast("");
    setSelectFile("");
    setSelectZD("");
  };

  const _onCreated = (e) => {
    if (geofenceDrawModeRef.current) return;
    let type = e.layerType;
    let layer = e.layer;
    if (type == "rectangle") {
      setHasDrawnShape(true);
      const bounds = layer.getBounds();
      const requestBody = {
        _southWest: bounds.getSouthWest(),
        _northEast: bounds.getNorthEast(),
        department: "",
        departmentList: selectedDepartmentRef.current
          ? [selectedDepartmentRef.current]
          : department
      };
      loggerFactory.debug(
        componentName,
        "Request body for areaSelected : ",
        requestBody,
      );
      activityLog(
        "event",
        "Announcement Play",
        "Broadcast File Play",
        UserNumber,
        "Selection Area",
        `${userName} Announcement Broadcast File Play in Selection Area`,
      );
      application.post("/gis/areaSelected", requestBody);
    } else {
      setOpenOnCreate(true);
      application
        .post("userGroupMaster/listAll")
        .then((response) => {
          setGroupList(response.data.data);
        })
        .catch((error) => {
          console.error("Failed to get data-", error);
        });
    }
  };

  const _onDeleted = (e) => {
    let numDeleted = 0;
    e.layers.eachLayer((layer) => {
      numDeleted += 1;
    });
    if (numDeleted > 0) {
      setHasDrawnShape(false);
    }
    loggerFactory.debug(
      componentName,
      `onDeleted: removed ${numDeleted} layers`,
      e,
    );
  };

  const disableGeofenceDrawTool = () => {
    if (geofenceDrawControlRef.current && mapRef.current) {
      mapRef.current.removeControl(geofenceDrawControlRef.current);
      geofenceDrawControlRef.current = null;
    }
    geofenceDrawModeRef.current = false;
    setGeofenceDrawActive(false);
    if (redrawTargetRef.current) {
      redrawTargetRef.current = null;
      geofenceDispatch(clearGeofenceRedraw());
    }
  };

  const toggleGeofenceDrawTool = () => {
    if (!mapRef.current || !geofenceDrawItemRef.current) return;

    if (geofenceDrawModeRef.current) {
      disableGeofenceDrawTool();
      return;
    }

    const control = new L.Control.Draw({
      position: "topleft",
      draw: {
        polygon: {
          shapeOptions: { color: "#3388ff", fillColor: "#3388ff", fillOpacity: 0.3 },
        },
        circle: {
          shapeOptions: { color: "#3388ff", fillColor: "#3388ff", fillOpacity: 0.3 },
        },
        rectangle: {
          shapeOptions: { color: "#3388ff", fillColor: "#3388ff", fillOpacity: 0.3 },
        },
        polyline: false,
        marker: false,
        circlemarker: false,
      },
      edit: false,
    });

    mapRef.current.addControl(control);
    geofenceDrawControlRef.current = control;
    geofenceDrawModeRef.current = true;
    setGeofenceDrawActive(true);
  };

  const _onGeofenceCreated = (e) => {
    if (!geofenceDrawModeRef.current || !geofenceDrawItemRef.current) return;

    const { layer, layerType } = e;
    geofenceDrawItemRef.current.addLayer(layer);
    pendingGeofenceLayerRef.current = layer;

    let shapePayload = null;
    if (layerType === "circle") {
      const center = layer.getLatLng();
      shapePayload = {
        shapeType: "CIRCLE",
        centerLat: String(center.lat),
        centerLng: String(center.lng),
        radiusMeters: layer.getRadius(),
      };
    } else {
      const rawLatLngs = layer.getLatLngs();
      const ring = Array.isArray(rawLatLngs[0]) ? rawLatLngs[0] : rawLatLngs;
      shapePayload = {
        shapeType: layerType === "rectangle" ? "RECTANGLE" : "POLYGON",
        coordinates: ring.map((point) => ({
          lat: String(point.lat),
          lng: String(point.lng),
        })),
      };
    }

    const target = redrawTargetRef.current;
    if (target) {
      // Resize/redraw of an existing fence: save the new geometry directly,
      // preserving name/color/assignments, instead of opening the create editor.
      redrawTargetRef.current = null;
      geofenceDispatch(clearGeofenceRedraw());
      geofenceDrawItemRef.current.removeLayer(layer);
      pendingGeofenceLayerRef.current = null;
      updateGeofence({
        id: target.id,
        name: target.name,
        color: target.color,
        shapeType: shapePayload.shapeType,
        coordinates: shapePayload.coordinates,
        centerLat: shapePayload.centerLat,
        centerLng: shapePayload.centerLng,
        radiusMeters: shapePayload.radiusMeters,
        assignedUsers: target.assignedUsers,
        assignedDepartments: target.assignedDepartments,
      })
        .unwrap()
        .then(() =>
          enqueueGeofenceSnackbar("Geofence shape updated", { variant: "success" }),
        )
        .catch(() =>
          enqueueGeofenceSnackbar("Unable to update geofence shape", { variant: "error" }),
        );
      disableGeofenceDrawTool();
      return;
    }

    setEditingGeofence(null);
    setPendingGeofenceShape(shapePayload);
    setGeofenceEditorOpen(true);
    disableGeofenceDrawTool();
  };

  const clearPendingGeofenceLayer = () => {
    if (pendingGeofenceLayerRef.current && geofenceDrawItemRef.current) {
      geofenceDrawItemRef.current.removeLayer(pendingGeofenceLayerRef.current);
    }
    pendingGeofenceLayerRef.current = null;
  };

  const handleGeofenceColorPreview = (color) => {
    if (pendingGeofenceLayerRef.current?.setStyle) {
      pendingGeofenceLayerRef.current.setStyle({ color, fillColor: color });
    }
  };

  const handleSelectZD = (value) => {
    setSelectZD(value);
    setIsZDValid(!!value);
  };

  const handleChangeGroup = (event) => {
    setSelectedGroup(event.target.value);
  };

  const handleFileSelect = (event) => {
    setSelectFile(event.target.value);
    setIsFileValid(!!event.target.value);
  };

  const handleSaveButton = () => {
    const isZone = !!selectZD.zone;
    const isDepartment = !!selectZD.department;

    if (!selectZD) {
      setIsZDValid(false);
      return;
    }

    setIsZDValid(true);

    const apiEndpoint = isZone ? "zone" : isDepartment ? "department" : "";

    if (!apiEndpoint) return;

    const selectedValue = isZone ? selectZD.zone : selectZD.department;
    const number = isZone ? selectZD.extension : selectZD.extension;

    if (clickButtonName === "message") {
      if (!messageToBroadcast) {
        setIsMessageValid(false);
        return;
      }
      setIsMessageValid(true);
      const body = {
        [apiEndpoint]: selectedValue,
        messageDetail: messageToBroadcast,
      };
      application.post(`chatMessage/sendSocket/${apiEndpoint}`, body);
      activityLog(
        "message",
        "Announcement Message",
        "Alert Message",
        UserNumber,
        selectedValue,
        `${userName} send broadcast message in ${selectedValue} ,  message : ${messageToBroadcast}`,
      );
      setMessageToBroadcast("");
    } else if (clickButtonName === "announcement") {
      const body = { callType: "muxing", [apiEndpoint]: selectedValue };
      application.post(`extensions/call/${apiEndpoint}`, body);
      activityLog(
        "event",
        "Announcement Call",
        "Alert Call",
        UserNumber,
        selectedValue,
        `${userName} dial broadcast call in ${selectedValue}`,
      );
    } else if (clickButtonName === "page") {
      if (!selectFile) {
        setIsFileValid(false);
        return;
      }

      setIsFileValid(true);

      const body = { wavFile: selectFile, [apiEndpoint]: selectedValue };
      application.post(`extensions/play/${apiEndpoint}`, body);
      let fileName = selectFile?.split(".")[0];
      activityLog(
        "event",
        "Announcement Play",
        "Broadcast File Play",
        UserNumber,
        selectedValue,
        `${userName} Announcement Broadcast  ${selectFile} File Play in ${selectedValue}`,
      );
      setSelectFile("");
    } else if (clickButtonName === "Recording_Announcement") {
      setRTCEvent(dispatch, {
        value: selectZD.department || selectZD.zone,
        type: "announcement",
        data: number,
      });
    } else if (clickButtonName == "GroupCall") {
      setRTCEvent(dispatch, {
        value: selectZD.department || selectZD.zone,
        type: "GroupCall",
        data: number,
      });
    }
    setSelectZD("");
    setSelectedZone(false);
  };

  const activityLog = (
    event,
    eventCategory,
    eventStatus,
    callerNumber,
    destinationNumber,
    eventData,
  ) => {
    const bodyData = {
      event: event,
      eventCategory: eventCategory,
      eventStatus: eventStatus,
      callerNumber: callerNumber,
      destinationNumber: destinationNumber,
      eventData: {
        msg: eventData,
      },
      userId: userName,
      deviceId: UserNumber,
      epochDate: Math.floor(Date.now() / 1000),
    };
    application.post("activityLog/create", bodyData);
  };

  const handleMessageChange = (event) => {
    setMessageToBroadcast(event.target.value);
    setIsMessageValid(!!event.target.value);
  };

  const centerMapOnCurrentLocation = (persistLocation = false) => {
    const fallbackLocation = Array.isArray(window?.locationAsHome)
      ? [window.locationAsHome[0], window.locationAsHome[1]]
      : homeLocation;

    const moveToFallbackLocation = () => {
      if (Array.isArray(fallbackLocation)) {
        updateMAPLocation(fallbackLocation);
        if (persistLocation) {
          setHomeLocation(fallbackLocation);
        }
      }
    };

    if (navigator.geolocation) {
      if (persistLocation) {
        setLocationUpdateColor("info");
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (persistLocation) {
            showPosition(position);
            return;
          }

          const currentLocation = [
            position.coords.latitude,
            position.coords.longitude,
          ];

          loggerFactory.debug(componentName, currentLocation);
          updateMAPLocation(currentLocation);
        },
        () => {
          moveToFallbackLocation();
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
      return;
    }

    loggerFactory.debug(
      componentName,
      "Geolocation is not supported by this browser.",
    );
    moveToFallbackLocation();
  };

  const lockOnCurrentLocation = () => {
    centerMapOnCurrentLocation(true);
  };

  const navigateToLocation = () => {
    centerMapOnCurrentLocation(false);
  };

  const updateMAPLocation = (newLocation) => {
    mapRef.current.setView(newLocation, mapDefaultZoom);
  };

  function getLocation() {
    centerMapOnCurrentLocation(true);
  }

  function showPosition(position) {
    setLocationUpdateColor("warn");
    loggerFactory.debug(componentName, [
      position.coords.latitude,
      position.coords.longitude,
    ]);
    updateMAPLocation([position.coords.latitude, position.coords.longitude]);
    setHomeLocation([position.coords.latitude, position.coords.longitude]);
    AuthenticationService.setLocation(
      position.coords.latitude,
      position.coords.longitude,
    );
  }

  // Resolve any incoming value (department code OR its description) to the
  // matching department record. This keeps matching correct even when
  // `department` (code) and `departmentDescription` (name) differ.
  function findDepartmentRecord(value) {
    if (value === undefined || value === null || value === "") {
      return undefined;
    }
    return departmentList?.find(
      (item) =>
        item.department === value || item.departmentDescription === value,
    );
  }

  function getColorByDepartment(department) {
    const departmentInfo = findDepartmentRecord(department);
    return departmentInfo && departmentInfo.color
      ? departmentInfo.color
      : "gray";
  }

  function checkDepartmentMatch(marker, selectedDepartment) {
    if (!selectedDepartment) {
      return null;
    }
    // Compare on the department CODE regardless of which form each side holds.
    const selectedCode =
      findDepartmentRecord(selectedDepartment)?.department || selectedDepartment;
    const markerCode =
      findDepartmentRecord(marker.department)?.department || marker.department;
    return selectedCode === markerCode;
  }

  function getMarkerIcon(marker) {
    const color = getColorByDepartment(marker.department);
    let customIcon;
    const size = checkDepartmentMatch(marker, selectedDepartment);

    if (marker.tagType === "imsi") {
      if (marker.emergencyStatus) {
        customIcon = markerEmergency;
      } else if (marker.registered) {
        customIcon = renderIconWithColor(color, size);
      } else {
        customIcon = markerEnemy;
      }
    } else {
      customIcon = markerEnemy;
    }
    customIcon.options.iconSize = [0, 0];
    customIcon.options.iconAnchor = [10, 15];
    return customIcon;
  }

  const handleMarkerMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const handleClickClose = () => {
    setOpen(false);
    setMessage("");
    setSelectedMarker("");
  };

  const handleOnCreateClose = () => {
    setOpenOnCreate(false);
    setSelectedGroup("");
  };

  const sendMessage = async () => {
    if (!message.trim() || !selectedMarker) return;
    const payload = {
      kind: "D",
      sender: AuthenticationService.getExtensionNumber(),
      target: selectedMarker,
      content: message,
      messageType: "text",
    };
    try {
      await telemetry.post("/chat/message", payload);
      setMessage("");
      setOpen(false);
    } catch (err) {
      setNotify({
        isOpen: true,
        pagename: "Chat",
        status: "Failed to send message",
        type: "error",
      });
    }
  };

  const handleSelectUser = async (user) => {
    const payload = {
      extension: user.user.extensionNumber,
      fromDate: user.from,
      toDate: user.to,
    };

    try {
      const res = await telemetry.post(`routeCoordinate/user`, payload);
      setOpenUserDialog(false);
      setUserPaths(res.data.data);
      setNotify({
        isOpen: true,
        message: res?.data?.messageDetails || "User paths fetched successfully",
        type: "success",
        pagename: componentName,
        status: res?.data?.message,
      });
    } catch (error) {
      setOpenUserDialog(false);
      setUserPaths([]);
      loggerFactory.error(`Error fetching user paths: ${error.message}`, {
        error,
      });
      setNotify({
        isOpen: true,
        status:
          error?.response?.data?.messageDetails || "Failed to fetch user paths",
        type: "error",
        pagename: componentName,
        message: error?.response?.data?.message,
      });
    }
  };

  // ── Inline action button helpers ──────────────────────────────────────────
  function ActionBtn({ tooltip, icon, color = "info", onClick, active = false, disabled = false }) {
    const theme = useTheme();
    const paletteColor = theme.palette[color]?.main || theme.palette.info.main;
    return (
      <Tooltip title={tooltip} placement="left" arrow>
        <span>
          <IconButton
            size="small"
            onClick={onClick}
            disabled={disabled}
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              border: `1px solid ${alpha(paletteColor, active ? 0.55 : 0.35)}`,
              bgcolor: alpha(paletteColor, active ? 0.18 : 0.08),
              color: disabled ? "text.disabled" : paletteColor,
              transition: "all 0.18s ease",
              "& .MuiSvgIcon-root": { fontSize: 19 },
              "&:hover": {
                bgcolor: alpha(paletteColor, 0.24),
                transform: "scale(1.05)",
                boxShadow: `0 3px 10px ${alpha(paletteColor, 0.3)}`,
              },
              "&.Mui-disabled": { opacity: 0.38 },
            }}
          >
            {icon}
          </IconButton>
        </span>
      </Tooltip>
    );
  }

  function ActionDivider() {
    return (
      <Box sx={{ width: "70%", borderBottom: `1px solid ${alpha("#888", 0.3)}`, my: 0.3 }} />
    );
  }
  // ─────────────────────────────────────────────────────────────────────────

  return (
    <MDBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <style>{`
        .leaflet-bar a,
        .leaflet-bar a:link,
        .leaflet-bar a:visited {
          background-color: #2c2c3a !important;
          color: #e0e0e0 !important;
          border-bottom: 1px solid rgba(255,255,255,0.12) !important;
        }
        .leaflet-bar a:hover {
          background-color: #3a3a4d !important;
          color: #ffffff !important;
        }
        .leaflet-bar a.leaflet-disabled {
          background-color: #1e1e28 !important;
          color: #555 !important;
        }
        .leaflet-bar {
          border: 1px solid rgba(255,255,255,0.15) !important;
          border-radius: 6px !important;
          box-shadow: 0 2px 8px rgba(0,0,0,0.45) !important;
          overflow: hidden;
        }

        /* Hide default Leaflet draw/edit/delete mode buttons */
        .leaflet-draw-toolbar,
        .leaflet-draw-toolbar-top {
          display: none !important;
        }

        /* Hide Leaflet draw action popup completely */
        .leaflet-draw-actions,
        .leaflet-draw-actions-top,
        .leaflet-draw-actions-bottom {
          display: none !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
      `}</style>
      <Box sx={{ height: "100%", flex: 1, position: "relative" }}>
          {homeLocation && (
            <>
              <MapControls
                onZoomIn={handleZoomIn}
                onZoomOut={handleZoomOut}
                onResetView={handleResetView}
                isFullscreen={isFullscreen}
                onToggleFullscreen={handleToggleFullscreen}
                mapMode={mapMode}
                onToggleMapMode={handleToggleMapMode}
                showLabels={false}
                onToggleLabels={handleToggleLabels}
                isStreetViewMode={isStreetViewMode}
                onToggleStreetView={handleToggleStreetView}
                showArea={showArea}
                onToggleArea={() => setShowArea((prev) => !prev)}
                showRoute={showRoute}
                onToggleRoute={() => setShowRoute((prev) => !prev)}
              />

              {/* ── Right-side action panel (inline, absolute) ── */}
              <Box
                sx={(theme) => ({
                  position: "absolute",
                  top: 80,
                  right: 1,
                  zIndex: 1000,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.55,
                  py: 0.6,
                  px: 0.4,
                  bgcolor:
                    mapMode === "satellite"
                      ? alpha(theme.palette.grey[900], 0.82)
                      : alpha(theme.palette.common.white, 0.9),
                  backdropFilter: "blur(10px)",
                  borderRadius: "10px",
                  border: `1px solid ${alpha(
                    theme.palette.divider,
                    mapMode === "satellite" ? 0.25 : 0.18,
                  )}`,
                  boxShadow: `0 4px 18px ${alpha(
                    theme.palette.common.black,
                    mapMode === "satellite" ? 0.45 : 0.14,
                  )}`,
                  overflowY: "auto",
                  maxHeight: "calc(100% - 100px)",
                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": { display: "none" },
                })}
              >
                {/* Recording Page */}
                <ActionBtn tooltip="Recording Page" icon={<MicIcon />} color="error"
                  onClick={() => recordingAnnouncementClick("Recording_Announcement")} />

                {/* Broadcast File */}
                <ActionBtn tooltip="Page (Broadcast File)" icon={<CampaignIcon />} color="warning"
                  onClick={() => pageClick("page")} />

                {/* Dial or Group Call */}
                {!isDisable && (
                  <ActionBtn tooltip="Dial" icon={<CallIcon />} color="success"
                    onClick={() => announcementClick("announcement")} />
                )}
                {isDisable && (
                  <ActionBtn tooltip="Group Call" icon={<GroupIcon />} color="success"
                    onClick={() => groupCallClick("GroupCall")} />
                )}

                {/* Live Group Call */}
                <ActionBtn tooltip="Live Group Call" icon={<LiveTvIcon />} color="info"
                  onClick={() => setLiveGroupCallOpen(true)} />

                {/* Message */}
                {!isDisable && (
                  <ActionBtn tooltip="Message" icon={<ForumIcon />} color="info"
                    onClick={() => messageClick("message")} />
                )}

                {/* Dispatcher Group Call */}
                {!isDisable && <DispatcherGroupCall compact />}

                {/* Emergency */}
                {!isDisable && (
                  <ActionBtn tooltip="Public Emergency" icon={<WarningAmberIcon />} color="error"
                    onClick={() => onEmergencyClick()} />
                )}

                {/* Navigate to home */}
                <ActionBtn tooltip="Navigate to Home Location" icon={<MyLocationIcon />} color="warning"
                  onClick={() => navigateToLocation()} />

                {/* View User Route */}
                <ActionBtn tooltip="View User Route" icon={<PersonPinCircleIcon />} color="info"
                  onClick={() => setOpenUserDialog((prev) => !prev)} />

                <ActionDivider />

                {/* Draw Area */}
                <ActionBtn tooltip="Draw Area" icon={<CropFreeIcon />}
                  color={isDrawing ? "success" : "info"}
                  active={isDrawing}
                  onClick={() => {
                    if (drawControlRef.current && mapRef.current) {
                      mapRef.current.addControl(drawControlRef.current);
                      const btn = document.querySelector(".leaflet-draw-draw-rectangle");
                      btn?.click();
                    }
                  }}
                />

                {/* Draw Geofence */}
                <ActionBtn tooltip="Draw Geofence" icon={<PentagonIcon />}
                  color={geofenceDrawActive ? "success" : "info"}
                  active={geofenceDrawActive}
                  onClick={toggleGeofenceDrawTool}
                />

                {/* Edit Area */}
                <ActionBtn tooltip="Edit Area" icon={<EditIcon />} color="warning"
                  disabled={!hasDrawnShape}
                  onClick={() => {
                    if (!mapRef.current || !drawItemRef.current || !hasDrawnShape) return;

                    if (editHandlerRef.current) {
                      editHandlerRef.current.disable();
                      editHandlerRef.current = null;
                      setIsDrawing(false);
                      return;
                    }

                    const editHandler = new L.EditToolbar.Edit(mapRef.current, {
                      featureGroup: drawItemRef.current,
                    });
                    editHandler.enable();
                    editHandlerRef.current = editHandler;
                    setIsDrawing(true);
                  }}
                />

                {/* Delete Area */}
                <ActionBtn tooltip="Delete Area" icon={<DeleteOutlineIcon />} color="error"
                  disabled={!hasDrawnShape}
                  onClick={() => {
                    if (editHandlerRef.current) {
                      editHandlerRef.current.disable();
                      editHandlerRef.current = null;
                    }

                    if (drawItemRef.current) {
                      drawItemRef.current.clearLayers();
                    }

                    setHasDrawnShape(false);
                    setIsDrawing(false);
                  }}
                />
              </Box>

              <div
                id="map"
                ref={mapContainerRef}
                style={{
                  height: "100%",
                  cursor: isStreetViewMode ? "crosshair" : "default",
                }}
                center={homeLocation}
                zoom={mapDefaultZoom}
              >
                <AreaSelect
                  onAreaSelect={(coordinates) => {
                    application.post("/gis/areaSelected", coordinates);
                  }}
                />
              </div>
            </>
          )}
      </Box>
          <GeofenceEditorDialog
            open={geofenceEditorOpen}
            shape={pendingGeofenceShape}
            geofence={editingGeofence}
            onColorChange={handleGeofenceColorPreview}
            onClose={() => {
              clearPendingGeofenceLayer();
              setGeofenceEditorOpen(false);
              setPendingGeofenceShape(null);
              setEditingGeofence(null);
            }}
            onSaved={() => {
              clearPendingGeofenceLayer();
              setGeofenceEditorOpen(false);
              setPendingGeofenceShape(null);
              setEditingGeofence(null);
            }}
          />
          <Dialog
            open={selectedZone}
            onClose={onCloseForm}
            fullWidth
            maxWidth="sm"
            classes={{ dialog }}
            sx={(theme) => CTLDialogContent(theme, { darkMode })}
            PaperProps={{
              sx: (theme) => ({
                borderRadius: 3,
                overflow: "hidden",
                border: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
                boxShadow: `0 16px 36px ${alpha(theme.palette.common.black, 0.24)}`,
                ...CTLDialogContent(theme, { darkMode }),
              }),
            }}
          >
            <DialogTitle
              sx={(theme) => ({
                ...CTLDialogContent(theme, { darkMode }),
                pb: 1.5,
                borderBottom: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
              })}
              id="alert-dialog-title"
            >
              <MDTypography
                variant="h6"
                fontWeight="bold"
                sx={{ color: "info.main" }}
              >
                {`Broadcast ${clickButtonName} to selected zone / department`}
              </MDTypography>
              <MDTypography
                variant="caption"
                sx={{ color: "text", mt: 0.4, display: "block" }}
              >
                Choose zone or department to continue.
              </MDTypography>
            </DialogTitle>
            <DialogContent
              sx={(theme) => ({
                ...CTLDialogContent(theme, { darkMode }),
                pt: 2.5,
                display: "grid",
                gap: 1.5,
              })}
            >
              <>
                <Autocomplete
                  style={{ paddingTop: "10px" }}
                  options={[
                    ...zoneList.map((item) => ({
                      label: item.zone || item.extension,
                      group: "Zone List",
                      value: item,
                    })),
                    ...departmentList.map((item) => ({
                      label: item.department || item.extension,
                      group: "Department List",
                      value: item,
                    })),
                  ]}
                  groupBy={(option) => option.group}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) =>
                    handleSelectZD(newValue?.value || "")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Zone / Department"
                      variant="outlined"
                      fullWidth
                      error={!isZDValid}
                      helperText={!isZDValid ? "This field is required." : ""}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} style={{ paddingLeft: "30px" }}>
                      {option.label}
                    </li>
                  )}
                  value={
                    selectZD
                      ? {
                          label:
                            zoneList.find((item) => item === selectZD)?.zone ||
                            departmentList.find((item) => item === selectZD)
                              ?.department ||
                            selectZD,
                          value: selectZD,
                        }
                      : null
                  }
                />

                {clickButtonName == "page" && (
                  <>
                    {" "}
                    <FormControl fullWidth error={!isFileValid}>
                      <InputLabel>Select Broadcast File</InputLabel>

                      <Select
                        name="Select File"
                        value={selectFile}
                        style={{ height: "55px" }}
                        label="Select Broadcast File"
                        onChange={handleFileSelect}
                        fullWidth
                      >
                        <MenuItem key="" value="">
                          Select
                        </MenuItem>
                        {fileList &&
                          fileList.map((item) => (
                            <MenuItem key={item.id} value={item.wavFile}>
                              {item.description}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>
                        {!isFileValid && "Please select a broadcast file."}
                      </FormHelperText>
                    </FormControl>
                  </>
                )}
                {clickButtonName == "message" && (
                  <>
                    <Divider></Divider>
                    <TextField
                      fullWidth
                      label="Type your message"
                      multiline
                      rows={4}
                      defaultValue=""
                      value={messageToBroadcast}
                      onChange={handleMessageChange}
                      error={!isMessageValid}
                      helperText={
                        isMessageValid
                          ? ""
                          : "Message cannot be empty. Please enter a message."
                      }
                    />
                  </>
                )}
              </>
            </DialogContent>
            <DialogActions
              sx={(theme) => ({
                ...CTLDialogContent(theme, { darkMode }),
                px: 3,
                pb: 2,
                pt: 1.5,
                borderTop: `1px solid ${alpha(theme.palette.info.main, 0.14)}`,
              })}
            >
              {clickButtonName == "messageHistory" ? (
                <MDButton
                  onClick={onCloseForm}
                  color="error"
                  variant="outlined"
                  sx={{ borderRadius: "999px", px: 2.5 }}
                >
                  Close
                </MDButton>
              ) : (
                <>
                  <MDButton
                    onClick={onCloseForm}
                    color="secondary"
                    variant="outlined"
                    sx={{ borderRadius: "999px", px: 2.5 }}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    color="success"
                    variant="gradient"
                    autoFocus
                    onClick={() => handleSaveButton()}
                    sx={{ borderRadius: "999px", px: 3 }}
                  >
                    Submit
                  </MDButton>
                </>
              )}
            </DialogActions>
          </Dialog>
      <Dialog open={open} maxWidth="sm" classes={{ dialog }}>
        <DialogTitle
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            pb: 1.5,
            borderBottom: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
            background: darkMode
              ? alpha(theme.palette.info.dark, 0.28)
              : alpha(theme.palette.common.white, 0.97),
          })}
          id="alert-dialog-title"
        >
          <MDTypography
            variant="h6"
            fontWeight="bold"
            sx={{ color: "info.main" }}
          >
            Send Message
          </MDTypography>
          <MDTypography
            variant="caption"
            sx={{ color: "text.secondary", mt: 0.4, display: "block" }}
          >
            Type your message to broadcast.
          </MDTypography>
        </DialogTitle>
        <DialogContent
          sx={(theme) => CTLDialogContent(theme, { darkMode })}
          style={{ paddingTop: "10px" }}
        >
          <MDBox sx={{ width: 500 }}>
            <TextField
              fullWidth
              id="outlined-multiline-flexible"
              variant="outlined"
              label="Type Message"
              value={message}
              onChange={handleMarkerMessageChange}
              multiline
              rows={6}
            />
          </MDBox>
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={() => handleClickClose()} color="secondary">
            Cancel
          </MDButton>
          <MDButton onClick={() => sendMessage()} color="success" autoFocus>
            Send
          </MDButton>
        </DialogActions>
      </Dialog>
      <UserRouteDialog
        open={openUserDialog}
        onClose={() => setOpenUserDialog(false)}
        users={data}
        handleSelectUser={handleSelectUser}
      />
      <Dialog
        open={openOnCreate}
        onClose={() => handleOnCreateClose()}
        maxWidth="md"
        classes={{ dialog }}
      >
        <DialogTitle
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            pb: 1.5,
            borderBottom: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
            background: darkMode
              ? alpha(theme.palette.info.dark, 0.28)
              : alpha(theme.palette.common.white, 0.97),
          })}
          id="alert-dialog-title"
        >
          <MDTypography
            variant="h6"
            fontWeight="bold"
            sx={{ color: "info.main" }}
          >
            Select Area Action
          </MDTypography>
          <MDTypography
            variant="caption"
            sx={{ color: "text.secondary", mt: 0.4, display: "block" }}
          >
            Choose a group to assign this area.
          </MDTypography>
        </DialogTitle>
        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDTypography variant="caption">{`Select Group`}</MDTypography>
          <Select
            value={selectedGroup}
            style={{ height: "55px" }}
            onChange={handleChangeGroup}
            name="Select Group"
            fullWidth
          >
            <MenuItem key="select" value="">
              Select
            </MenuItem>
            {groupList &&
              groupList.map((item) => (
                <MenuItem key={item.code} value={item}>
                  {item.description}
                </MenuItem>
              ))}
          </Select>
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={() => handleOnCreateClose()} color="secondary">
            Cancel
          </MDButton>
          <MDButton
            onClick={() => handleOnCreateClose()}
            color="success"
            autoFocus
          >
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
      <LiveGroupCall
        liveGroupCallOpen={liveGroupCallOpen}
        setLiveGroupCallOpen={setLiveGroupCallOpen}
      />
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}
